import React from "react";
import { NetHourlyReportView, NET_HOURLY_TICKETING } from "./NetHourlyReport";

// RP-2175 — Ticketing Net Hourly. The Net Hourly page (RP-2162), restricted to the ticketing channel:
// the report types force OrderType = Ticketing server-side, so the page is otherwise identical (By day /
// Combined, Per hour / Cumulative, event/date/vendor/location filters, CSV export). Matches the legacy
// "Ticketing Net Hourly Sales Report" (days as rows, the 5 AM operating-day hours as columns).
export default function TicketingNetHourlyReport() {
  return <NetHourlyReportView config={NET_HOURLY_TICKETING} />;
}
